import { render } from "./HomeEvent.vue?vue&type=template&id=3ca9d60f"
import script from "./HomeEvent.vue?vue&type=script&lang=js"
export * from "./HomeEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__